// extracted by mini-css-extract-plugin
export var loaderCenter = "index-module--loaderCenter--1u5fj";
export var home = "index-module--home--31Z7Y";
export var dropdownContainer = "index-module--dropdownContainer--3dZoY";
export var formContainer = "index-module--formContainer--1xtNG";
export var d1 = "index-module--d1--xho-D";
export var d2 = "index-module--d2--1R3eQ";
export var pairButton = "index-module--pairButton--evDIs";